export type Tomo = {
  id: string
  emoji: string
  title: string
  subtitle: string
  description: string
}

export type Bono = {
  number: string
  title: string
  description: string
  price: string
}

export type Testimonial = {
  initials: string
  name: string
  meta: string
  quote: string
}

export type FaqItem = {
  question: string
  answer: string
}

export type ComparisonRow = {
  situation: string
  without: string
  with: string
}

export type CostRow = {
  without: string
  cost: string
}

export const tomos: Tomo[] = [
  {
    id: 'T1',
    emoji: '🖊️',
    title: 'Tomo 1 — Pre-escritura',
    subtitle: 'Manos que Trazan',
    description:
      'Postura, agarre, trazos rectos, curvos, espirales, laberintos y motricidad fina.',
  },
  {
    id: 'T2',
    emoji: '✏️',
    title: 'Tomo 2 — Las Vocales',
    subtitle: 'El Universo de la A, E, I, O, U',
    description:
      'Reconocimiento, trazo, sonido y vocabulario argentino de cada vocal.',
  },
  {
    id: 'T3',
    emoji: '🔡',
    title: 'Tomo 3 — Consonantes',
    subtitle: 'Paso a Paso',
    description:
      'Las 9 consonantes fundamentales con silabario completo y primeras palabras.',
  },
  {
    id: 'T4',
    emoji: '📖',
    title: 'Tomo 4 — Sílabas',
    subtitle: 'y Primeras Palabras',
    description:
      'Silabario completo, palabras de 2 y 3 sílabas, primeras oraciones y dictado.',
  },
  {
    id: 'T5',
    emoji: '📝',
    title: 'Tomo 5 — Comprensión Lectora',
    subtitle: 'y Oraciones',
    description:
      'Textos narrativos argentinos, preguntas de comprensión, escritura propia y ortografía básica.',
  },
  {
    id: 'T6',
    emoji: '✍️',
    title: 'Tomo 6 — Caligrafía Cursiva',
    subtitle: 'Argentina',
    description:
      'Trazos base, vocales, consonantes, palabras, frases y primera carta en cursiva.',
  },
]

export const tomoIncludes: string[] = [
  'Presentación modular por letra o habilidad',
  'Actividades fotocopiables listas para imprimir',
  'Secuencia de trazos paso a paso con flechas y puntos de inicio',
  'Vocabulario 100% argentino (mate, asado, hornero, pampa, potrero)',
  'Diplomas imprimibles por tomo',
  'Registro de progreso con tabla de seguimiento',
  'Guía para adultos en cada tomo',
  '100% alineado al nivel inicial y primer ciclo argentino',
]

export const bonos: Bono[] = [
  {
    number: '01',
    title: 'Guía de Inicio Rápido: Primeros 7 Días Sin Estrés',
    description:
      'Empezá el MegaPack en 10 minutos y sabé exactamente qué hacer la primera semana.',
    price: '$8.000',
  },
  {
    number: '02',
    title: 'Planificador Semanal de Lectoescritura',
    description: '8 semanas de organización para casa y aula sin improvisar.',
    price: '$10.000',
  },
  {
    number: '03',
    title: 'Tracker de Progreso "Mi Camino de Lector"',
    description:
      'Registro visual que convierte cada avance en una victoria que el niño/a puede ver y tocar.',
    price: '$9.000',
  },
  {
    number: '04',
    title: 'Kit de Juegos Relámpago',
    description:
      '30 juegos de 5 minutos para practicar letras, sílabas y palabras sin que parezca tarea.',
    price: '$8.000',
  },
  {
    number: '05',
    title: 'Guía de Corrección Amable',
    description:
      'Cómo corregir errores de escritura y lectura sin frustrar ni apagar las ganas de aprender.',
    price: '$9.000',
  },
  {
    number: '06',
    title: 'Pack de Mini Certificados y Celebraciones de Logros',
    description:
      '20 tarjetas de logro + medallas + certificados semanales + Gran Diploma Final de serie.',
    price: '$9.000',
  },
]

export const painPoints: string[] = [
  'Domingo buscando actividades que nunca están adaptadas al español rioplatense',
  'Fichas armadas a la noche sin saber si el niño/a está en el nivel correcto',
  'Siempre las mismas letras repetidas porque no tenés un banco de actividades serio',
  'La cursiva, las sílabas, la comprensión lectora — sin progresión clara ni paso a paso',
  'Grupos con distintos niveles sin material diferenciado — trabajás al promedio y perdés a todos',
  'Fin de semana agotado, domingo volvés a empezar el mismo ciclo',
]

export const topTestimonials: Testimonial[] = [
  {
    initials: 'MG',
    name: 'Mariela G.',
    meta: 'Córdoba',
    quote:
      'Organicé todo el proceso de mi hija en una tarde. El registro de progreso me ahorra horas cada semana y ella pide practicar sola.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    meta: 'Rosario · Escuela Primaria',
    quote:
      'La cursiva por fin se entiende. Los módulos con secuencia de trazos son el hit de mi aula de primer grado.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    meta: 'Buenos Aires · Psicopedagogo',
    quote:
      'Mis alumnos de apoyo por fin avanzan con un sistema. El Tomo 5 de comprensión lectora vale cada peso.',
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    initials: 'CR',
    name: 'Cecilia R.',
    meta: '📍 Mendoza · MegaPack + Kit Inclusión',
    quote:
      'El sistema de 3 versiones me salvó la vida. Ya no armo dos materiales distintos. Mi alumno con dislexia por fin participa igual que todos.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    meta: '📍 Buenos Aires · Psicopedagogo',
    quote:
      'Con el juego del tren de sílabas, en 10 minutos el grupo entero estaba leyendo palabras sin vergüenza ni presión.',
  },
  {
    initials: 'SC',
    name: 'Sofía C.',
    meta: '📍 La Plata · Docente de primer grado',
    quote:
      'Mis alumnos de primer grado terminaron el año leyendo oraciones completas. Eso no pasaba con el material anterior.',
  },
  {
    initials: 'PA',
    name: 'Pablo A.',
    meta: '📍 Neuquén · Papá de Valentina',
    quote:
      'La Guía de Corrección Amable fue un antes y un después. Dejé de pelearme con mi hija en cada sesión.',
  },
]

export const kitComparison: ComparisonRow[] = [
  {
    situation: 'El niño/a no puede hacer la actividad estándar',
    without: 'Improvisás en el momento',
    with: 'Versión BÁSICA lista en 30 segundos',
  },
  {
    situation: 'Necesitan evaluación diferenciada',
    without: 'La armás el domingo a la noche',
    with: 'Actividad diferenciada. Ya está.',
  },
  {
    situation: 'Dirección pide registro de adecuaciones',
    without: 'Buscás algo que no encontrás',
    with: 'Plantilla firmada. Profesional.',
  },
  {
    situation: 'Alumno/a con dislexia no puede leer el material',
    without: 'Dictás o simplificás',
    with: 'Ficha de lectura simplificada. Ya está hecha.',
  },
  {
    situation: 'Distintos niveles juntos en el mismo grupo',
    without: 'Perdés a todos',
    with: 'Protocolo de aula abierta. Todos avanzan.',
  },
  {
    situation: 'Niño/a con poca tolerancia a la frustración',
    without: 'Termina llorando o negándose',
    with: 'Protocolo de 3 minutos. Sale siempre.',
  },
]

export const kitIncludes: string[] = [
  'Sistema de 3 versiones de cada actividad (básica, estándar, avanzada)',
  'Fichas de lectura simplificada',
  'Actividades diferenciadas listas',
  'Guía para NEE y dificultades de aprendizaje',
  'Protocolo de aula abierta para niveles mixtos',
  'Banco de actividades de ritmo lento',
  'Tarjetas visuales de apoyo',
]

export const faqItems: FaqItem[] = [
  {
    question: '¿Sirve para todos los niveles?',
    answer:
      'Sí. El MegaPack cubre desde los 4 años (pre-escritura y motricidad fina en el Tomo 1) hasta los 9-10 años (cursiva avanzada en el Tomo 6). El test de nivel incluido en el Bono 1 te ayuda a saber exactamente por dónde empezar.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Apenas confirmado el pago, recibís un email con el enlace de descarga. En menos de 5 minutos tenés todo en tu dispositivo. Podés imprimir lo que necesitás o usarlo en pantalla.',
  },
  {
    question: '¿Qué lo diferencia del material que encuentro online gratis?',
    answer:
      'El material online genérico no está adaptado al español rioplatense argentino. Este MegaPack usa vocabulario, costumbres y ejemplos 100% argentinos. Además incluye la secuencia pedagógica completa, los registros de progreso y las guías para adultos que el material gratuito no tiene.',
  },
  {
    question: '¿Tiene garantía real?',
    answer:
      'Sí. 7 días de garantía completa. Si no cumple tus expectativas, escribís a soporte y te devolvemos el 100% sin preguntas.',
  },
]

export const costRows: CostRow[] = [
  {
    without: '3 hs de búsqueda de material × 40 semanas',
    cost: '120 horas de tu vida por año',
  },
  {
    without: 'Actividades sin solucionario ni guía',
    cost: 'Domingos de armado sin criterios claros',
  },
  {
    without: 'Material NEE inventado en el momento',
    cost: 'Desgaste + riesgo pedagógico',
  },
  {
    without: 'Grupos con distintos niveles sin sistema',
    cost: 'Niños/as que se pierden y no vuelven',
  },
  {
    without: 'Sin registro de progreso visible',
    cost: 'El avance existe pero nadie lo ve',
  },
  {
    without: 'El mismo ciclo de búsqueda',
    cost: 'El mismo agotamiento, el próximo año',
  },
]

export const purchaseNotices: { name: string; product: string; minutes: number }[] = [
  { name: 'Florencia B. de La Plata', product: 'MegaPack + Kit Inclusión 🏆', minutes: 9 },
  { name: 'Diego S. de Rosario', product: 'MegaPack Caligrafía y Lectoescritura 📘', minutes: 14 },
  { name: 'Carla V. de Salta', product: 'MegaPack + Kit Inclusión 🏆', minutes: 21 },
  { name: 'Verónica T. de Mar del Plata', product: 'MegaPack Caligrafía y Lectoescritura 📘', minutes: 27 },
]

export const CHECKOUT_MEGAPACK =
  'https://www.novarecursos.online/cart/45090138194128:1'

export const CHECKOUT_MEGAPACK_KIT =
  'https://www.novarecursos.online/cart/45090384216272:1'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/94159581-ae08-4a7f-8e60-97f4fa1825c3.jpg'
